<template>
    <div>
        <nav-bar></nav-bar>

        <div class="container">

            <div class="section">

              <nav class="breadcrumb" aria-label="breadcrumbs">
                  <ul>
                    <li><a @click="$router.push('/clients')">Chatbots</a></li>
                    <li><a @click="$router.push('/clients/'+client+'/intents')">{{clientName}}</a></li>
                    <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">{{intentName}}</a></li>
                    <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">{{sentenceName}}</a></li>
                    <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences/'+sentence+'/answers')">Respuestas</a></li>
                    <li class="is-active"><a href="#" aria-current="page">Nueva Respuesta</a></li>
                  </ul>
              </nav>

              <!-- TABS -->
              <div class="tabs is-toggle">
                <ul>
                  <li :class="{'is-active': isActiveTab('text')}" @click="showTab('text')">
                    <a>
                      <span class="icon is-small"><i class="fas fa-envelope" aria-hidden="true"></i></span>
                      <span>texto</span>
                    </a>
                  </li>
                  <li :class="{'is-active': isActiveTab('process')}" @click="showTab('process')">
                    <a>
                      <span class="icon is-small"><i class="fas fa-laptop-code" aria-hidden="true"></i></span>
                      <span>proceso</span>
                    </a>
                  </li>
                  <li :class="{'is-active': isActiveTab('file')}" @click="showTab('file')">
                    <a>
                      <span class="icon is-small"><i class="fas fa-file" aria-hidden="true"></i></span>
                      <span>archivo</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div v-if="isActiveTab('text')">
                <div class="field">
                      <label class="label">Respuesta</label>
                      <div class="control">
                          <textarea class="textarea" placeholder="Frase" v-model="answer.response" id="sentence" @focus="sentencePosition = 0">
                          </textarea>
                      </div>
                  </div>
                  <div>
                    <label class="label">Añadir elementos</label>
                    <label class="checkbox label">
                      <input type="checkbox" v-model="showEmojis" @click="activate('emojis')">
                      {{ showEmojis ? 'Ocultar Emojis' : 'Mostrar Emojis' }}
                    </label>
                    <emojis v-if="showEmojis" :emojis="emojis" @emoji-selected="addElement"></emojis>
                    <label class="checkbox label">
                        <input type="checkbox" v-model="showCreateButton" @click="activate('button')">
                        {{ showCreateButton ? 'Ocultar creación botón' : 'Añadir botón'}}
                    </label>
                    <buttons v-if="showCreateButton" @button-syntax="addElement"></buttons>
                    <label class="checkbox label">
                        <input type="checkbox" v-model="showAddDoc" @click="activate('doc')">
                        {{ showAddDoc ? 'Ocultar creación documento' : 'Añadir documento'}}
                    </label>
                    <documents v-if="showAddDoc" @doc-syntax="addElement"></documents>
                    <new-message-button @new-message="addElement"></new-message-button>
                  </div>
                  <br>
              </div>

              <!-- PROCESS -->
              <div v-if="isActiveTab('process')">

                <div class="field">
                  <label class="label">Proceso</label>
                  <div class="control">
                        <textarea class="textarea" placeholder="Url del proceso" v-model="answer.process">
                        </textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Método</label>
                  <div class="control">
                    <div class="select is-medium">
                      <select v-model="answer.method">
                        <option v-for="method in methods" :key="method.idTypeResponse" :value="method.idTypeResponse">
                          {{method.typeResponse}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Content-Type</label>
                  <div class="control">
                    <div class="select is-medium">
                      <select v-model="answer.contentType">
                        <option v-for="contentType in contentTypes" :key="contentType.idTypeResponse" :value="contentType.idTypeResponse">
                          {{contentType.typeResponse}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Parámetros de sustitución</label>
                  <div class="control">
                        <textarea class="textarea" placeholder="TERMINO_A_ENCONTRAR: {nombre_parametro}" v-model="answer.parametersList">
                        </textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Parámetros de la URL de proceso</label>
                  <div class="control">
                        <textarea class="textarea" placeholder="Parámetros" v-model="answer.parameters">
                        </textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Respuesta</label>
                  <div class="control">
                        <textarea class="textarea" placeholder="Frase" v-model="answer.response" id="sentence" @focus="sentencePosition = 0">
                        </textarea>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Respuesta de ayuda</label>
                  <div class="control">
                        <textarea class="textarea" placeholder="Frase" v-model="answer.responseHelp">
                        </textarea>
                  </div>
                </div>

                <label class="checkbox label">
                  <input type="checkbox" v-model="showEmojis" @click="activate('emojis')">
                  {{ showEmojis ? 'Ocultar Emojis' : 'Mostrar Emojis' }}
                </label>
                <emojis v-if="showEmojis" :emojis="emojis" @emoji-selected="addElement"></emojis>
                <br>
              </div>

              <div v-if="isActiveTab('file')">
                <br>
                <div class="field">
                  <label class="label">Archivo</label>
                  <div class="file has-name is-fullwidth">
                    <label class="file-label">
                      <input ref="image" class="file-input" type="file" name="resume" accept="image/*" @change="setImage">
                      <span class="file-cta">
                                    <span class="file-icon"><i class="fas fa-upload"></i></span>
                                    <span class="file-label">Selecciona un archivo</span>
                                </span>
                      <span class="file-name">{{imageName}}</span>
                    </label>
                  </div>
                </div>
                <br><br>
              </div>
              <br>
              <div class="button is-primary is-left" @click="storeAnswer">
                <span class="icon"><i class="fas fa-save fa-lg"></i></span>
                <span class="is-capitalized">Guardar</span>
              </div>
            </div>

        </div>
    </div>

</template>

<script>
import Strings from '../../../../lib/Strings'
import Emojis from '../../../templates/Emojis'
import Buttons from '../../../templates/Buttons'
import Documents from '../../../templates/Documents'
import NewMessageButton from '../../../templates/NewMessageButton'

export default {
  components: {Emojis, Buttons, Documents, NewMessageButton},
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      sentence: this.$route.params.sentence,
      sentenceName: 'Frase',
      activeTab: 'text',
      imageName: null,
      answer: {
        file: null,
        idIntent: 0,
        idDictionary: 0,
        response: '',
        languageId: 0,
        type: null
      },
      emojis: [],
      emoji: null,
      showEmojis: false,
      showCreateButton: false,
      showAddDoc: false,
      sentencePosition: 0,
      undefinedRegExp: /^undefined{1}/
    }
  },
  created () {
    this.getEmojis()
    this.getContentTypes()
    this.getMethods()
    this.breadcrumbDetails()
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', {idIntent: this.$route.params.intent}).then(response => {
        this.intentName = response.intent.name
      })
      this.api.post('/PhraseById', {idDictionary: this.sentence}).then(response => {
        this.sentenceName = response.phrase.term
      })
    },
    showTab (tab) {
      this.activeTab = tab
    },
    isActiveTab (tab) {
      return this.activeTab === tab
    },
    getEmojis () {
      this.api.post('/DataEmojiList').then(response => {
        this.emojis = response.emojis
        this.emojis.shift()
      })
    },
    addElement(syntax) {
      let startPosition = document.getElementById('sentence').selectionStart;
      if (startPosition === 0 && this.sentencePosition === 0) {
        this.answer.response = syntax + this.answer.response;
        return
      }
      let array = Array.from(this.answer.response);
      const position = this.sentencePosition === 0
        ? startPosition
        : this.sentencePosition;
        
      array[position - 1] += syntax;
      this.sentencePosition = position + syntax.length;
      array[position - 1] = array[position - 1].replace(this.undefinedRegExp, '');
      
      array = array.join("");
      this.answer.response = array;
    },
    activate(param) {
      const options = {
        emojis: this.showEmojis = false,
        button: this.showCreateButton = false,
        doc: this.showAddDoc = false
      };

      Object.keys(options).forEach(([key, value]) => param !== key && value);
    },
    setImage () {
      let files = this.$refs.image.files

      if (!files.length) {
        this.imageName = null
        return
      }

      this.answer.file = files[0]
      this.imageName = this.answer.file.name
    },
    getContentTypes () {
      this.api.post('/DataTypeContentList').then(response => {
        this.contentTypes = response.typesResponse
        this.answer.contentType = this.contentTypes[0].idTypeResponse
      })
    },
    getMethods () {
      this.api.post('/DataTypeMethodList').then(response => {
        this.methods = response.typesResponse
        this.answer.method = this.methods[0].idTypeResponse
      })
    },
    storeAnswer () {
      if (this.isActiveTab('process')) {
        if (!this.answer.process) {
          Event.$emit('showModal', 'Es obligatorio rellenar una URL de proceso')
          return
        }

        if (this.answer.method === this.methods[0].idTypeResponse) {
          Event.$emit('showModal', 'Es obligatorio seleccionar un método')
          return
        }

        if (this.answer.contentType === this.contentTypes[0].idTypeResponse) {
          Event.$emit('showModal', 'Es obligatorio seleccionar un content-type')
          return
        }
      }

      this.answer.idDictionary = this.sentence

      let endpoint = ''
      let method = 'post'

      switch (this.activeTab) {
        case 'process':
          endpoint = '/ResponseRegisterProcess'
          break
        case 'file':
          method = 'multipart'
          endpoint = '/ResponseRegisterFile'
          break
        default:
          endpoint = '/ResponseRegister'
      }

      let parametersList = {}

      if (this.answer.parametersList) {
        parametersList = Strings.encodeProcessParameters(this.answer.parametersList)
      }

      this.api[method](endpoint, {...this.answer, parametersList}).then(() => {
        this.$router.back()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/answers/StoreAnswer.vue